import "./Style/style.scss";
import userHelper from "./helper/user";
import { useState, useEffect } from "react";
//import "bootstrap/dist/css/bootstrap.min.css";
import CardList from "./Components/card-list/cardList";
import Footer from "./Components/footer/Footer";
import Header from "./Components/header/Header";

function App() {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [nameUser, setNameUser] = useState("");
  const [authServerAccess, setAuthServerAccess] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        var result = await userHelper.me();
        setApplications(result.apps);
        setNameUser(result.name);
        setAuthServerAccess(result.admin);
      } catch (error) {
        window.location.href = process.env.REACT_APP_LOGIN_URL;
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <>
      <Header nameUser={nameUser} authServerAccess={authServerAccess} />
      <div id="main-content" className="">
        <div className="container pt-5">
          {!!loading ? (
            <div className="row d-flex justify-content-center">
              <div className="spinner-border " role="status" />
            </div>
          ) : !!applications.length ? (
            <>
            <div className="app-header">
              <h1>Seleziona un’applicazione</h1>
              {authServerAccess && (
                <a
                  href={`${process.env.REACT_APP_API_BASE_URL}/dashboard`}
                  className="btn btn-secondary"
                  style={{
                    background: '#163B63',
                  }}
                >
                  Accesso al server <i className="la la-arrow-right ml-2"></i>
                </a>
              )}
            </div>
            <CardList applications={applications} />
            </>
          ) : (
            <>
            <div className="app-header">
              <h1>Seleziona un’applicazione</h1>
              {authServerAccess && (
                <a
                  href={`${process.env.REACT_APP_API_BASE_URL}/dashboard`}
                  className="btn btn-secondary"
                >
                  Accesso al server <i className="la la-arrow-right ml-2"></i>
                </a>
              )}
            </div>
            <div className="empty-state">
              <i className="la la-ban"></i>
              <h2>Nessuna applicazione disponibile</h2>
              <p>Non sei autorizzato all’utilizzo di alcuna applicazione.</p>
            </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default App;
